import React, { useEffect, useState } from "react";
import { BiExport } from "react-icons/bi";
import { MdClear } from "react-icons/md";
import { useQuery } from "react-query";
import { HistroyReportApi, HistroyReportDownloadApi, UserListApi } from "../../Api";
import { AxiosResponse } from "axios";
import { HistroyReportType } from "../../type";
import { RenderPaginationButtons } from "../../../Components/Paginations";
import { formatDate as FormateDate } from "../../../helper/index";
import { Dropdown } from "react-bootstrap";
import { saveAs } from "file-saver";
import { isJSONString } from "../Chatbox/ChatBox";
import { BsFiletypeDoc, BsFiletypeDocx, BsFiletypePdf, BsFiletypeXls, BsFiletypeXlsx } from "react-icons/bs";
import { FaFile } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";

function formatDate(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export default function HistroyReport() {
  const [Data, setData] = useState<HistroyReportType[]>([]);
  const [selectDateName, setSelectDateName] = useState("Select Date");
  const [info, setInfo] = useState<{
    count: number;
    current_page: number;
    limit: number;
    total_page: number;
  }>();
  const [Filter, setFilter] = useState<{
    message_type: string;
    direction: string;
    to: string;
    status: string;
    from_date: string;
    to_date: string;
  }>({
    message_type: "",
    direction: "",
    to: "",
    status: "",
    from_date: "",
    to_date: "",
  });
  const [page, setPage] = useState(1);

  const Report = useQuery({
    queryKey: ["History-Report", page, Filter],
    queryFn: HistroyReportApi,
    onSuccess: (resp: AxiosResponse) => {
      setData(resp.data?.data || []);
      setPage(resp.data?.info?.current_page || 1);
      setInfo(resp?.data?.info);
    },
    enabled: false,
  });

  const ReportDownload = useQuery({
    queryKey: ["History-Report-Download", page, Filter],
    queryFn: HistroyReportDownloadApi,
    onSuccess: (resp: AxiosResponse) => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(resp.data)
      link.download = `History_Report_${new Date().toISOString()}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    enabled: false,
  });

  useEffect(() => {
    Report.refetch();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    Report.refetch();
    // eslint-disable-next-line
  }, [page, selectDateName]);

  useEffect(() => {
    setPage(1)
    const handler = setTimeout(() => {
      Report.refetch();
    }, 300);

    return () => {
      clearTimeout(handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Filter.to, Filter.message_type, Filter.direction, Filter.status]);

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= (info?.total_page || 1)) {
      setPage(page);
    }
  };

  const handleClearSearchFilter = () => {
    setSelectDateName("Select Date")
    setFilter({
      message_type: "",
      direction: "",
      to: "",
      status: "",
      from_date: "",
      to_date: "",
    });
  };

  const downloadMedia = async (imgUrl: string) => {
    fetch(imgUrl)
      .then((response) => response.blob())
      .then((blob) => {
        saveAs(blob, imgUrl.split("/").pop());
      })
      .catch(() => { });
  };

  return (
    <section className="content">
      <div className="container-fluid">
        <div className="card mt-4">
          <div className="rounded-top bg-white p-3 d-md-flex justify-content-sm-between">
            <div className="d-sm-flex justify-content-between w-100 flex-wrap gap-3">
              <h2 className="mb-0 fs-3 d-block d-md-inline">SMS History Report</h2>
              <div className="d-flex justify-content-between mt-sm-0 mt-3">
                <button
                  onClick={handleClearSearchFilter}
                  className="btn btn-secondary d-flex align-items-center justify-content-center  w-100"
                  style={{ minWidth: 130 }}
                >
                  <MdClear className="fs-5" />
                  Clear Filter
                </button>
                <button
                  onClick={() => ReportDownload.refetch()}
                  style={{ minWidth: 130 }}
                  className="btn btn-success d-flex align-items-center justify-content-center ms-2 w-100"
                  disabled={ReportDownload.isFetching}
                >
                  <BiExport className="fs-5" />
                  {ReportDownload.isFetching ? "Exporting.." : "Export"}
                </button>
              </div>
            </div>
          </div>
          <div className="card-body border-start-0 border-end-0 p-0 ">
            <div className="table-responsive">
              <table className="table table-hover table-bordered text-nowrap" style={{ minHeight: "320px" }}>
                <thead>
                  <tr>
                    <th style={{ width: 200 }}>SR No</th>
                    <th style={{ minWidth: 200, maxWidth: 350 }}>
                      Message Type
                    </th>
                    <th style={{ minWidth: 200, maxWidth: 350 }}>Number</th>
                    <th style={{ minWidth: 200, maxWidth: 350 }} className="text-center">Direction</th>
                    <th style={{ minWidth: 200, maxWidth: 350 }} className="text-center">Message</th>
                    <th style={{ minWidth: 200, maxWidth: 350 }} className="text-center">Media</th>
                    <th style={{ minWidth: 200, maxWidth: 350 }} className="text-center">Status</th>
                    <th style={{ minWidth: 200, maxWidth: 350 }} className="text-center">Created At</th>
                  </tr>
                  <tr>
                    <th></th>
                    <th>
                      <select
                        style={{ width: 240 }}
                        value={Filter.message_type || ""}
                        className="form-control w-100 "
                        onChange={(e) => {
                          if (e.target.value === "All")
                            return setFilter({ ...Filter, message_type: "" });
                          setFilter({
                            ...Filter,
                            message_type: e.target.value,
                          });
                        }}
                      >
                        <option value="All">All</option>
                        <option value="Individual">Individual</option>
                        <option value="Broadcast">Broadcast</option>
                      </select>
                    </th>
                    <th>
                      <input
                        className="form-control"
                        value={Filter.to}
                        onChange={(e) =>
                          setFilter({ ...Filter, to: e.target.value })
                        }
                      />
                    </th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>
                      <select
                        style={{ width: 240 }}
                        value={Filter.status || ""}
                        className="form-control w-100"
                        onChange={(e) => {
                          if (e.target.value === "All")
                            return setFilter({ ...Filter, status: "" });
                          setFilter({
                            ...Filter,
                            status: e.target.value,
                          });
                        }}
                      >
                        <option value="">All Status</option>
                        <option value="0">Pending</option>
                        <option value="1">Sent</option>
                        <option value="2">Delivered</option>
                        <option value="3">Undelivered</option>
                        <option value="4">Failed</option>
                        <option value="5">Delivery Unknown</option>
                        <option value="6">Delivery Unconfirmed</option>
                        <option value="7">Unknown Gateway</option>
                      </select>
                    </th>
                    <th className="">
                      <Dropdown className="w-100" style={{ zIndex: 999 }}>
                        <Dropdown.Toggle
                          className="fw-semibold m-0 border-1 border w-100 form-control"
                          variant="transparent"
                        >
                          {selectDateName}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="p-3 Date-Filter-Menu ">
                          <div className="d-flex flex-column">
                            <label className="mb-2 fw-semibold">From</label>
                            <input
                              type="date"
                              name="from"
                              value={Filter.from_date}
                              onChange={(e) =>
                                setFilter({
                                  ...Filter,
                                  from_date: e.target.value,
                                })
                              }
                              className="form-control mb-3"
                            />

                            <label className="mb-2 fw-semibold">To</label>
                            <input
                              type="date"
                              name="to"
                              value={Filter.to_date}
                              onChange={(e) =>
                                setFilter({
                                  ...Filter,
                                  to_date: e.target.value,
                                })
                              }
                              className="form-control mb-3"
                            />

                            <div className="d-flex justify-content-between">
                              <button
                                className="btn btn-primary w-100 me-1"
                                onClick={() => {
                                  if (Filter.from_date && Filter.to_date) {
                                    setPage(1)
                                    setSelectDateName(`${Filter.from_date} To ${Filter.to_date}`);
                                  }
                                }}
                              >
                                Apply
                              </button>

                              <button
                                className="btn btn-secondary w-100 ms-1"
                                onClick={() => {
                                  setSelectDateName("Select Date");
                                  setFilter({
                                    ...Filter,
                                    from_date: "",
                                    to_date: ""
                                  });
                                }}
                              >
                                Clear
                              </button>
                            </div>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {Data && Data[0] ? (
                    Data.map((item, i) => (
                      <tr>
                        <td style={{ minWidth: 200, maxWidth: 350 }}>
                          {i + 1 + (page - 1) * 10}
                        </td>
                        <td style={{ minWidth: 200, maxWidth: 350 }}>
                          {item?.message_type || ""}
                        </td>
                        <td style={{ minWidth: 200, maxWidth: 350 }}>
                          {item?.to || ""}
                        </td>
                        <td className="text-center" style={{ minWidth: 200, maxWidth: 350 }}>
                          {item?.direction || ""}
                        </td>
                        <td
                          className="text-center"
                          style={{
                            minWidth: 200,
                            maxWidth: 350,
                            wordBreak: "break-word",
                            textWrap: "wrap",
                            overflow: "hidden",
                          }}
                        >
                          {item?.message || ""}
                        </td>


                        <td className="text-center">
                          <div
                            className={`d-flex justify-content-center px-3 gap-2 flex-wrap`}
                          >
                            {(!item?.media_url || JSON.parse(item?.media_url).length === 0) ? (
                              <p className="mb-0">-</p>
                            ) : (
                              isJSONString(item?.media_url) &&
                              JSON.parse(item?.media_url).map(
                                (
                                  item: { media_url: string; content_type: string },
                                  i: number
                                ) => {
                                  if (item?.content_type?.startsWith("image/"))
                                    return (
                                      <div
                                        className="showImages bg-dark d-block"
                                        key={i}
                                        style={{ height: 75, width: 75 }}
                                      >
                                        <FiDownload
                                          color="black"
                                          className="my-1 removeImageBtn p-1"
                                          style={{ height: 25, width: 25 }}
                                          onClick={() =>
                                            downloadMedia(item?.media_url)
                                          }
                                        />
                                        <img
                                          style={{ width: "100%", height: "100%" }}
                                          src={item?.media_url}
                                          alt="img"
                                          className="shadow-none object-fit-contain"
                                        />
                                      </div>
                                    );
                                  else
                                    return (
                                      <div
                                        className={`showImages bg-dark overflow-hidden`}
                                        style={{ height: 75, width: 75 }}
                                        key={i}
                                      >
                                        <FiDownload

                                          color="black"
                                          className="my-1 removeImageBtn"
                                          onClick={() =>
                                            downloadMedia(item?.media_url)
                                          }
                                        />
                                        <div className="w-100 h-100 d-flex flex-column justify-content-between">
                                          <div className="d-flex flex-grow-1 justify-content-center align-items-center">
                                            {item?.content_type ===
                                              "application/vnd.ms-excel" ? (
                                              <BsFiletypeXls
                                                className="w-100 text-success"
                                                style={{ height: 35 }}
                                              />
                                            ) : item?.content_type ===
                                              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                                              <BsFiletypeXlsx
                                                className="w-100 text-success"
                                                style={{ height: 35 }}
                                              />
                                            ) : item?.content_type ===
                                              "application/msword" ? (
                                              <BsFiletypeDoc
                                                className="w-100 text-primary"
                                                style={{ height: 35 }}
                                              />
                                            ) : item?.content_type ===
                                              "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                                              <BsFiletypeDocx
                                                className="w-100 text-primary"
                                                style={{ height: 35 }}
                                              />
                                            ) : item?.content_type ===
                                              "application/pdf" ? (
                                              <BsFiletypePdf
                                                className="w-100 text-danger"
                                                style={{ height: 35 }}
                                              />
                                            ) : (
                                              <FaFile
                                                className="w-100"
                                                style={{ height: 35 }}
                                              />
                                            )}
                                          </div>
                                          <p
                                            className="mb-2 fs-11 text-center"
                                            style={{ fontSize: 11 }}
                                          >
                                            {/* {item?.name} */}
                                          </p>
                                        </div>
                                      </div>
                                    );
                                }
                              )
                            )}
                          </div>
                        </td>

                        <td
                          style={{ minWidth: 200, maxWidth: 350 }}
                          className={`text-center ${item?.status === 0
                            ? "text-warning fw-bold"
                            : item?.status === 1
                              ? "text-success fw-bold"
                              : item?.status === 2
                                ? "text-success fw-bold"
                                : item?.status === 3
                                  ? "text-danger fw-bold"
                                  : item?.status === 4
                                    ? "text-danger fw-bold"
                                    : item?.status === 5
                                      ? "text-info fw-bold"
                                      : item?.status === 6
                                        ? "text-info fw-bold"
                                        : item?.status === 7
                                          ? "text-secondary fw-bold"
                                          : "text-muted"
                            }`}
                        >
                          {item.status === 0
                            ? "Pending"
                            : item.status === 1
                              ? "Sent"
                              : item.status === 2
                                ? "Delivered"
                                : item.status === 3
                                  ? "Undelivered"
                                  : item.status === 4
                                    ? "Failed"
                                    : item.status === 5
                                      ? "Delivery Unknown"
                                      : item.status === 6
                                        ? "Delivery Unconfirmed"
                                        : item.status === 7
                                          ? "Unknown Gateway"
                                          : " - "}
                        </td>
                        <td style={{ minWidth: 200, maxWidth: 350 }} className="text-center">
                          {FormateDate(item?.createdAt) || ""}
                        </td>
                      </tr>
                    ))
                  ) : !Report.isFetching ? (
                    <tr>
                      <td colSpan={8} height={50}>
                        <div className="text-center">
                          <p className="mb-0 fs-5 fw-semibold">
                            No data found
                          </p>
                        </div>
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
              {Report.isFetching ? (
                <center className="mb-3">
                  <i
                    className=" my-2 fa loader"
                    style={{ fontSize: "30px", color: "black" }}
                  ></i>
                </center>
              ) : null}
            </div>
            {info && info.total_page ? (
              <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                <RenderPaginationButtons
                  info={info}
                  currentPage={page}
                  handlePageChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </section >
  );
}
